import React, { useState, useEffect } from "react";

import contentfulApi from "../../utils/contentful";

import headerImage from "../../assets/media-header-image.jpg";

import PageHeader from "../../components/PageHeader";
import Row from "../../components/Row";
import Col from "../../components/Col";
import Container from "../../components/Container";
import GetStarted from "../../components/GetStarted";

import Article from "../Press/Article";


const Media = (props) => {
  const [data, setData] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    contentfulApi
      .getEntries({
        content_type: "mediaPost",
        order: "-fields.publishedAt",
      })
      .then((response) => {
        setData(Object.assign(response.items));
        setDataLoaded(true);
      });
  }, [props]);

  if (!dataLoaded) {
    return null;
  }

  return (
    <div className="press media">
      <PageHeader>
        <Row>
          <Col md={5}>
            <h1>Papa in the press</h1>
            <hr />
            <p>
              Read on for how we’re delivering real impact. 
            </p>
          </Col>
          <img src={headerImage} alt="Papa in the press" className="page-header__image img-circle" />
        </Row>
      </PageHeader>

      <div className="press-cta">
        <Container>
            <Row>
              <Col md={8}>
                <h2>Interested in profiling Papa? Get in touch at <a href="mailto:press@papa.com">press@papa.com</a>.</h2>
              </Col>
            </Row>
        </Container>
      </div>

      <div className="press-articles">
        <Container>
          <div className="featured-article">
            <Row className="flex align-center">
              <Col md={6}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={data[0].fields.url}
                >
                  <img
                    src={data[0].fields.image.fields.file.url}
                    alt="Featured article"
                    className="img-responsive"
                  />
                </a>
              </Col>

              <Col md={6}>
                <h3 className="mb-30">{data[0].fields.title}</h3>
                <p>{data[0].fields.copy}</p>

                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={data[0].fields.url}
                >
                  Read More
                </a>
              </Col>
            </Row>
          </div>

          <Row>
            {data.slice(1).map((item, index) => (
              <Col md={3} key={`item_${index}`}>
                <a
                  href={item.fields.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Article image={item.fields.image.fields.file.url}>
                    <h4 className="mb-10">{item.fields.title}</h4>
                    <p>{item.fields.copy}</p>
                  </Article>
                </a>
              </Col>
            ))}
          </Row>

          {/* <div className="view-more text-center">
            <a href="#">View More</a>
          </div> */}
        </Container>
      </div>

      <GetStarted hideCall={true} />
    </div>
  );
};

export default Media;
